/**
 * Rule-Based Column Matching Engine for Mini Printer
 */

export function normalizeHeader(str: string): string {
  if (!str) return "";
  return str
    .replace(/^[\{\\[\s]+/, "")
    .replace(/[\}\]\s]+$/, "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/[\s\-_.:;,\/\\"'`~!@#$%^&*()=+|\[\]{}<>]/g, "");
}

export const SYNONYM_MAP: Record<string, string[]> = {
  supplier_name: ["nhacungcap", "tenncc", "nhacc", "supplier", "vendor", "tennhacungcap", "tennhacc"],
  supplier_code: ["mancc", "manhacungcap", "suppliercode", "manhacc"],

  // Order / PO / Delivery
  order_number: ["sopo", "madon", "madonhang", "po", "ponumber", "maphieu", "sochungtu", "sodondathang", "masodondathang"],
  delivery_date: ["ngaygiao", "ngaynhan", "ngaygiaohang", "deliverydate", "date", "ngaydukiengiaohangtoikho", "ngaydukien", "ngaydukiengiaohang", "ngaygiaodukien", "ngayyeucaugiaohang", "ngayhengiaohang"],

  // Store / Receiver
  store_name: [
    "cuahangnhan",
    "cuahang",
    "donvinhan",
    "khotong",
    "khonhan",
    "store",
    "tenchst",
    "tench",
    "tencuahang",
    "tencuahangdiem",
    "tencuahangnhan",
    "tencuahangnhanhang",
    "cuahangnhanhang",
    "sieuthicuahang",
    "sieuthinhanhang",
    "tendiemgiao",
    "diemgiao",
    "noiden",
  ],
  store_code: ["macuahang", "makho", "storecode", "machst", "mach", "mch", "macuahangdiem", "madiemgiao"],
  route_code: ["matuyen", "tuyen", "route"],
  address: ["diachi", "diadiem", "diachigiaohang", "diachidiemgiao", "diachincc", "diachinhanhang"],

  // Items / Table columns
  stt: ["stt", "seq", "no", "index"],
  item_code: ["mahang", "masp", "sku", "masanpham", "itemcode", "sap"],
  barcode: ["mavach", "gtin", "barcode", "upc", "ean", "mabarcodehanghoa", "mabarcode"],
  item_name: ["tenhang", "tensanpham", "tensp", "diengiai", "itemname", "productname", "mathang"],
  unit: ["donvitinh", "dvt", "unit", "quycach"],
  quantity: ["soluong", "sl", "qty", "quantity", "soluongdathang", "soluongdat"],
  received_quantity: [
    "thucnhan",
    "soluongthucnhan",
    "thucgiao",
    "slthucnhan",
    "receivedqty",
    "soluongthuctegiaohang",
  ],
  note: ["ghichu", "ghichuhang", "note", "remark"],
  weight: ["trongluong", "khoiluong", "weight", "trongluongkg", "khoiluongkg"],
  volume: ["thetich", "volume", "khoiluongthetich", "cbm"],
  package_count: ["sokien", "soxien", "socarton", "packages"],
  total_quantity: ["tongsoluong", "tongsl", "totalqty"],
  total_weight: ["tongtrongluong", "tongkhoiluong", "totalweight"],
};

export function matchColumn(target: string, columns: string[]): string | null {
  if (!target || columns.length === 0) return null;

  const normalizedTarget = normalizeHeader(target);
  if (!normalizedTarget) return null;

  // 1. Direct exact normalized match
  for (const col of columns) {
    if (normalizeHeader(col) === normalizedTarget) {
      return col;
    }
  }

  // 2. Synonym dictionary lookup
  for (const [key, synonyms] of Object.entries(SYNONYM_MAP)) {
    const isTargetKey = normalizedTarget === normalizeHeader(key) || synonyms.includes(normalizedTarget);
    if (isTargetKey) {
      for (const col of columns) {
        const normCol = normalizeHeader(col);
        if (normCol === normalizeHeader(key) || synonyms.includes(normCol)) {
          return col;
        }
      }
    }
  }

  // 3. Substring match
  for (const col of columns) {
    const normCol = normalizeHeader(col);
    if (normCol.length > 2 && (normCol.includes(normalizedTarget) || normalizedTarget.includes(normCol))) {
      return col;
    }
  }

  return null;
}
